import {Selector} from "@ngxs/store";
import {MyGroupsState, MyGroupsStateModel} from "@smatchy/domains/groups/state/my-groups.state";
import {GroupDetailsDto} from "@smatchy/sdk";

export class MyGroupsSelector {

  @Selector([MyGroupsState])
  static loading(state: MyGroupsStateModel): boolean {
    return state.loading;
  }

  @Selector([MyGroupsState])
  static groups(state: MyGroupsStateModel): GroupDetailsDto[] {    
    return state.groups;
  }
}
